import {
  CreateSegmentModel,
  List,
  SegmentContentModel,
  SegmentModel,
  SegmentWithContentModel,
  UpdateSegmentContentModel,
} from '@partful/instructions-domain-models';
import { BaseService } from '@partful/shared/api/baseService';

export class SegmentsService extends BaseService {
  async create(
    account: string,
    instructionId: string,
    versionId: string,
    args: CreateSegmentModel
  ): Promise<SegmentModel & Partial<SegmentWithContentModel>> {
    const res = await this.client.post(`/instructions/${instructionId}/versions/${versionId}/segments`, args, {
      params: { account },
    });
    return res.data;
  }

  async get(
    account: string,
    instructionId: string,
    versionId: string,
    segmentId: string,
    lang?: string
  ): Promise<SegmentModel & Partial<SegmentWithContentModel>> {
    const res = await this.client.get(`/instructions/${instructionId}/versions/${versionId}/segments/${segmentId}`, {
      params: { account, lang },
    });
    return res.data;
  }

  async list(
    account: string,
    instructionId: string,
    versionId: string,
    args: { nextToken?: string; lang?: string }
  ): Promise<List<SegmentModel & Partial<SegmentWithContentModel>>> {
    const res = await this.client.get<List<SegmentModel & SegmentWithContentModel>>(
      `/instructions/${instructionId}/versions/${versionId}/segments`,
      { params: { account, ...args } }
    );
    return res.data;
  }

  async delete(account: string, instructionId: string, versionId: string, segmentId: string): Promise<void> {
    await this.client.delete(`/instructions/${instructionId}/versions/${versionId}/segments/${segmentId}`, {
      params: { account },
    });
  }

  async updateContent(
    account: string,
    instructionId: string,
    versionId: string,
    segmentId: string,
    lang: string,
    updateArgs: UpdateSegmentContentModel
  ): Promise<SegmentContentModel> {
    const res = await this.client.patch(
      `/instructions/${instructionId}/versions/${versionId}/segments/${segmentId}/contents`,
      updateArgs,
      { params: { account, lang } }
    );
    return res.data;
  }
}
